import React from 'react';
import { useLocation } from 'react-router-dom';
import { get } from 'lodash';
import queryString from 'query-string';

import { MainLoader } from '@/components/shared/MainLoader';
import { useAuth } from '@/hooks/useAuth/useAuth';

export const AdminLoginPage = () => {
  const location = useLocation();
  const { loading, login } = useAuth();
  const adminLoginSessionId = get(queryString.parse(location.search, { decode: false }), 'session');

  React.useEffect(() => {
    if (adminLoginSessionId) {
      login({
        adminLoginSessionId: adminLoginSessionId.toString(),
        email: null,
        password: '',
      });
    }
  }, []);

  if (loading) {
    return <MainLoader fullscreen />;
  }

  return null;
};
